import { useState, useEffect } from 'react';
import axios from 'axios';
import { Table } from '../TradeCurrency/Table';
import { MdAccountCircle } from 'react-icons/md';
import { LiaStarSolid } from 'react-icons/lia';
import { formatDateStrToDate, getToken } from '../utils';
import { LoadingMode } from '../Components/LoadingMode';

function TransactionRatingTable() {
  const [ratings, setRatings] = useState([]);

  const { token: userToken } = getToken();

  const userId = getToken()?.user?.id;

  const tableHeader = [
    {
      //   Header: "",
      accessor: 'user',
    },
  ];
  useEffect(() => {
    const fetchAllReferes = async () => {
      const url = `${process.env.REACT_APP_BASE_URL}/rating/user`;

      try {
        const response = await axios.post(
          url,
          { user_id: userId },
          {
            headers: { Authorization: `Bearer ${userToken}` },
          }
        );
        setRatings(response.data.ratings);
        console.log('ratings user:', response.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchAllReferes();
  }, [userId, userToken]);

  const ratingsArray = ratings?.map((rating) => ({
    user: (
      <div className='flex flex-col gap-2 max-w-sm items-start'>
        <div className='flex flex-row gap-2 w-full justify-between'>
          <div className='flex flex-row gap-3 items-start'>
            <MdAccountCircle className='text-4xl -mt-1 text-b-mc/70 ' />

            <div className='flex flex-col w-full text-left'>
              <p>{rating?.cx_transaction?.unique_code}</p>
              <span className='flex flex-row gap-1 pb-4'>
                <LiaStarSolid className='text-orange-500' />
                <LiaStarSolid className='text-orange-500' />
                <LiaStarSolid className='text-orange-500' />
                <LiaStarSolid className='text-orange-500' />
                <LiaStarSolid className='text-orange-500' />
              </span>
              <p>{rating?.review} transcating with you</p>
            </div>
          </div>
          <p className='text-xs text-s-bk'>
            {formatDateStrToDate(rating?.created_at)}
          </p>
        </div>
      </div>
    ),
    // date: formatDate("en-US", rating?.created_at),
    // unique_code: rating?.cx_transaction?.unique_code,
    // rating_star: rating?.star,
    // review: rating?.review,
  }));

  return (
    <article className='mx-6'>
      {!!(ratingsArray.length === 0) ? (
        <LoadingMode />
      ) : (
        <Table columns={tableHeader} data={ratingsArray} />
      )}
    </article>
  );
}

export default TransactionRatingTable;
